<template>
  <div class="contenedor-cpanel">
    <BaseNotification2
      v-if="store.status.msg != null"
      :type="store.status.type"
      :text="store.status.msg"
      :closable="store.status.closable"
      @close="borrarNotificacion()"
    />
    <div class="contenedor-titulo">
      <h1>Puntos de Entrega</h1>
      <div class="barra"></div>
    </div>
    <section class="contenedor-tabla-punto-de-entrega">
      <router-link to="/agregar-punto-de-entrega" class="boton-agregar-punto">Agregar Punto de Entrega</router-link>
      <PuntosDeEntregaLista
      ></PuntosDeEntregaLista>
    </section>
  </div>
</template>

<script>
import store from '../store'
import BaseNotification2 from '../components/BaseNotification2'
import PuntosDeEntregaLista from '../components/PuntosDeEntregaLista.vue'
export default {
  name: 'PuntosDeEntrega',
  components: {
    PuntosDeEntregaLista,
    BaseNotification2
  },
  data: function () {
    return {
      store
    }
  },
  methods: {
    borrarNotificacion () {
      this.store.setStatus({
        msg: null,
        type: null,
        title: null
      })
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.borrarNotificacion()
    }, 4000)
  }
}
</script>

<style>

</style>
